'use strict';

/**
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 */
function updateGiftingInformation (defer, data) {
    if (data.html) {
        $('.checkout-product-summary')[0].outerHTML = data.html;
    }
    var expressMethodEnabled = true;
    var defaultApplePayMethod = true;
    var wrappedQuantity = 0;
    var giftKitQuantity = 0;

    if (data.order) {
        if (data.order.items) {
            const orderItems = data.order.items.items;
            for (let item of orderItems) {
                if (!item.wrappedQuantity || item.wrappedQuantity === 0) {
                    $('.js-gifting-container-' + item.UUID).addClass('hide');
                } else {
                    wrappedQuantity++;
                    expressMethodEnabled = false;
                    $('.js-gifting-container-' + item.UUID).removeClass('hide');
                    $('.js-wrapped-quantity-' + item.UUID).html(item.wrappedQuantity);
                }
                if (item.isGiftKit) {
                    giftKitQuantity++;
                    expressMethodEnabled = false;
                }
            }
        }
        const shipment = data.order.shipping;
        if (shipment && shipment.length > 0) {
            if (!shipment[0].selectedShippingMethod.isApplePayEnabled) {
                defaultApplePayMethod = false;
            }
        }
    }

    // Toggle gift wrap button area
    $('.js-wrap-buttons').toggleClass('hide', wrappedQuantity > 0);
    $('.js-wrap-links').toggleClass('hide', wrappedQuantity === 0);
    // Toggle gift kit button area
    $('.js-kit-buttons').toggleClass('hide', giftKitQuantity > 0);
    $('.js-kit-links').toggleClass('hide', giftKitQuantity === 0);

    if (expressMethodEnabled) {
        $('.js-paypal-container').removeClass('disabled');
        $('.js-amazon-pay-container').removeClass('disabled');
        $('.js-google-pay-container').removeClass('disabled');
        // if the shipping method selected is not the default courier, applePay button should be disabled
        if (defaultApplePayMethod) {
            $('.js-apple-pay-container:not(.js-apple-pay-standard-container)').removeClass('disabled');
        } else {
            $('.js-apple-pay-container:not(.js-apple-pay-standard-container)').addClass('disabled');
        }
    } else {
        $('.js-paypal-container').addClass('disabled');
        $('.js-apple-pay-container:not(.js-apple-pay-standard-container)').addClass('disabled');
        $('.js-amazon-pay-container').addClass('disabled');
        $('.js-google-pay-container').addClass('disabled');
    }
}

function resetGiftCardForm () {
    const $drawer = $('.giftCardDrawer');
    $drawer.find('.giftcard-amount-feedback').addClass('hidden');
    $drawer.find('.giftcardModalBlock').removeClass('hidden');
    $drawer.find('.buttonRemoveGiftcard').addClass('hide');
    $drawer.find('.buttonApplyGiftcard').removeClass('hide');
}

module.exports = {
    updateGiftingInformation: updateGiftingInformation,
    resetGiftCardForm: resetGiftCardForm
};
